import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/How to engage others to deliver.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>isn't it interesting?
                                            </div>
                                            <p>Have you ever been in a tug of war to get people to do their
                                                work?</p>


                                            <div className="border_subtitle">Knowing how to engage others to
                                                deliver
                                            </div>
                                            <div className="paraspace"><p>How do people become engaged in their
                                                jobs? Is it something about them, the job itself or can
                                                you as a manager motivate people so that they are involved in
                                                their jobs and give their best?
                                                Several studies examining management styles and levels of
                                                individual and team output have
                                                shown that telling people what and how to do their jobs might
                                                not be the best technique to get
                                                them going and that in the majority of cases, collaboration,
                                                motivation and involvement in decision
                                                making are vital to engage others.</p></div>

                                            <div className="lightgreencontentbg keyquestionpad ">
                                                <div className="border_subtitle">What works best for engaged
                                                    employees?
                                                </div>
                                                <p>In 1939, a group of researchers led by psychologist Kurt
                                                    Lewin<a className="superscripttext"
                                                            href="further_info.php?course=300"><sup>1</sup></a> set
                                                    out to identify
                                                    the impact of different leadership styles on team
                                                    productivity and morale. They examined
                                                    three different leader styles – authoritarian, laissez-faire
                                                    and democratic. The individual
                                                    and group outputs as well as general group atmosphere were
                                                    then compared between
                                                    the groups.</p>
                                                <p>They found that both individual and group performance as well
                                                    as the group atmosphere
                                                    (engaged and motivated) was highest in teams led by
                                                    democratic leaders – where people
                                                    were consulted about the goals of the group and the
                                                    approaches to take and where their
                                                    opinions were valued.</p>
                                                <div className="uiheading">
                                                    <p>The results led the researchers to believe that the
                                                        observed differences could not be
                                                        explained in terms of individual differences of
                                                        particular team members but was directly
                                                        related to the style with which these groups were
                                                        managed.</p></div>
                                            </div>


                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>
                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}